<script>
    import { selectedTags, selectedTagIds, selectedCates, selectedCateIds } from './store';
  


    function removeTag(tag) {
      selectedTags.update(tags => tags.filter(t => t.id !== tag.id));
      selectedTagIds.update(ids => ids.filter(id => id !== tag.id));
    }
    // Remove category from the selectedCates store
  function removeCategory(category) {
    selectedCates.update(cates => cates.filter(c => c.id !== category.id));
    selectedCateIds.update(ids => ids.filter(id => id !== category.id));
  }
  </script>




<div>
  {#if ($selectedTagIds.length !== 0)}
<ul class="selected-tags">
  
  
  <span class="text-md font-semibold">{$selectedTagIds.length > 1 ? "Tags" : "Tag"}:</span>
  
    {#each $selectedTags as tag}
      <li class="selected-tag text-sm font-semibold text-pm-grey p-1">
        {tag.value}
        <i class="font-normal si-solid si-xmark mt-[1px] remove cursor-pointer"  on:click={() => removeTag(tag)}></i>
      </li>
    {/each}
    </ul>
    {/if}  
  <!-- Render selected categories -->
  {#if ($selectedCateIds.length !== 0)}
    <ul class="selected-cates">
      
      
      <span class="text-md font-semibold">{$selectedCateIds.length > 1 ? "Categories" : "Category" }:</span>
        
      {#each $selectedCates as category}
        <li class="selected-cate text-sm font-semibold text-pm-grey p-1 m-1">
          {category.value}
          <i class="font-normal si-solid si-xmark mt-[1px] remove cursor-pointer" on:click={() => removeCategory(category)}></i>
        </li>
      {/each}
    </ul>
  {/if}
</div>
  <style>
   .selected-tags, .selected-cates {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    color: rgba(var(--pm-black));
  }

  .selected-tag {
    
    border-radius: 3px;
    display: inline-block;
  }

  .selected-tag .remove {
    margin-left: 5px;
    cursor: pointer;
  }
  </style>